import { Expose, Type, Exclude } from 'class-transformer';

import { Default, ExposeRawData, Plunk } from '@lib/common/decorators';
import { SnCollection, SnModel } from '@lib/common/models';

import { SnPullProtocol } from '../base';
import { SnLocation } from '../location';
import { SnApplianceBaseType } from './appliance-base-type';
import { FsAppliancesCameraCounts } from './appliance-camera-counts';
import { SnApplianceCapacityStatus } from './appliance-capacity-status';
import { SnApplianceStatus } from './appliance-status';
import { SnLiveApplication } from './live-application';
import { SnNetwork } from './network';

export class SnAppliance extends SnModel {
  @Expose()
  @Type(() => SnNetwork)
  @Default([])
  public network: SnNetwork[];

  @Expose()
  @Type(() => SnApplianceBaseType)
  public baseType: SnApplianceBaseType;

  @Expose()
  public id: string;

  @Expose()
  public vendorApiUrls: any;

  @Expose()
  public name: string;

  @Expose()
  @Type(() => FsAppliancesCameraCounts)
  public cameraCounts: FsAppliancesCameraCounts;

  @Expose()
  public isCloud: boolean;

  @Expose()
  public make: string;

  @Expose()
  public model: string;

  @Expose()
  public serialNumber: string;

  @Expose()
  public isLocal: boolean;

  @Expose()
  public isAiAppliance: boolean;

  @Expose()
  public supportedAiDetections: any[];

  @Expose()
  public proxyUrl: string;

  @Expose()
  public localProxyUrl: string;

  @Expose()
  public host: string;

  @Expose()
  public serverId: string;

  @Expose()
  public httpPort: number;

  @Expose()
  @Default(1935)
  public rtmpPort: number;

  @Expose()
  @Default(554)
  public rtspPort: number;

  @Expose()
  @Default(false)
  public pullSsl: boolean;

  @Expose()
  @Default(SnPullProtocol.RTSP)
  public pullProtocol: SnPullProtocol;

  @Expose()
  @Type(() => SnLocation)
  @Plunk('id', { toPlainOnly: true, groups: ['form'] })
  public location: SnLocation;

  @Expose()
  @Exclude({ toPlainOnly: true })
  @Type(() => SnLiveApplication)
  @Default(new SnCollection())
  public readonly liveApps: SnCollection<SnLiveApplication>;

  @Expose()
  public status: SnApplianceStatus;

  @Expose()
  public reportMeta: any;

  @ExposeRawData()
  public settings: any;

  @Expose({ name: 'statusChangeTimestamp' })
  @Type(() => Date)
  public statusChangeAt: Date;

  @Expose()
  @Default(SnApplianceCapacityStatus.Unknown)
  public capacityStatus: SnApplianceCapacityStatus;

  @Expose({ name: 'capacityStatusChangeTimestamp' })
  @Type(() => Date)
  public capacityStatusChangeAt: Date;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
